import './journal/JournalSansNew-Display.ttf';
import './journal/JournalSansNew-Italic.ttf';
import './journal/JournalSansNew-Oblique.ttf';
import './journal/JournalSansNew.ttf';



// WEBPACK FOOTER //
// ./fonts/index.js